export const DATA_KEYS = {
  field1: "props.title",
  dateField: "props.dateField",
  dimension: "props.dimension",
  interval: "props.interval",
  cyclical: "props.cyclical",
  selectedTimeRange: "props.selectedTimeRange",
  customTimeRange: "props.customTimeRange",
  // Visibility (show/hide) for breakdown dimension
  hiddenDimDatapoints: "props.hiddenDimDatapoints",
  dimVisibilityPreset: "props.dimVisibilityPreset",
  dimVisibilityN: "props.dimVisibilityN",
};
